let CryptoJS = require("crypto-js");

function _0x193f(_0x4fa9db, _0x52a0d6) {
  const _0x1ebb45 = _0x1ebb();
  return (
    (_0x193f = function (_0x193f86, _0x49570d) {
      _0x193f86 = _0x193f86 - 0x117;
      let _0x26160f = _0x1ebb45[_0x193f86];
      return _0x26160f;
    }),
    _0x193f(_0x4fa9db, _0x52a0d6)
  );
}

(function (_0x476d87, _0x395561) {
  const _0x27ee58 = _0x193f,
    _0x31a34a = _0x476d87();
  while (!![]) {
    try {
      const _0x45e74e =
        (parseInt(_0x27ee58(0x123)) / 0x1) *
          (parseInt(_0x27ee58(0x117)) / 0x2) +
        parseInt(_0x27ee58(0x120)) / 0x3 +
        (-parseInt(_0x27ee58(0x121)) / 0x4) *
          (parseInt(_0x27ee58(0x11d)) / 0x5) +
        (-parseInt(_0x27ee58(0x129)) / 0x6) *
          (-parseInt(_0x27ee58(0x126)) / 0x7) +
        -parseInt(_0x27ee58(0x119)) / 0x8 +
        parseInt(_0x27ee58(0x124)) / 0x9 +
        (parseInt(_0x27ee58(0x122)) / 0xa) * (parseInt(_0x27ee58(0x118)) / 0xb);
      if (_0x45e74e === _0x395561) break;
      else _0x31a34a["push"](_0x31a34a["shift"]());
    } catch (_0x5386b8) {
      _0x31a34a["push"](_0x31a34a["shift"]());
    }
  }
})(_0x1ebb, 0x595e6);

const _daferew53w7rhf6 = (_0x3c6d6a) => {
  const _0x385057 = _0x193f;
  let _0x52fb11 = CryptoJS[_0x385057(0x11f)][_0x385057(0x127)](
      (_0x3c6d6a && _0x3c6d6a?.[_0x385057(0x11b)]) ||
        _0x3c6d6a?.[_0x385057(0x11c)] ||
        "",
      _0x385057(0x125)
    ),
    _0x1e906c = JSON[_0x385057(0x11e)](
      _0x52fb11[_0x385057(0x128)](CryptoJS["enc"][_0x385057(0x11a)])
    );
  return _0x1e906c;
};

function _0x1ebb() {
  const _0x3d14f8 = [
    "5190066JsOLys",
    "txxugb4uke7384xewtww7zpcbbkugfd3cg7erkwbvj0yhzwlgh7cpyhzycvepzb7",
    "221851CECbhS",
    "decrypt",
    "toString",
    "54jJWiwK",
    "96614yIkzAk",
    "88121ZsOJoL",
    "5703320nWdSDJ",
    "Utf8",
    "response",
    "data",
    "64360WBHlHV",
    "parse",
    "AES",
    "1389030wmckAr",
    "184wppJxZ",
    "10uoktIe",
    "7ivLAQU",
  ];
  _0x1ebb = function () {
    return _0x3d14f8;
  };
  return _0x1ebb();
}

export default _daferew53w7rhf6;
